import { useEffect, useState } from "react";
import { getMomentum } from "../../../Services/journey";
import { useStandaloneHeader, JourneyBackHeader, JourneySubpageCard } from "../shared";
import { JourneySectionHead, MomentumDimensions } from "../blocks";
import { JOURNEY_HOME_COPY } from "../copy";
import "../style.css";

/**
 * Your Momentum (/journey/momentum) — Momentum v2 (guide §5.1c).
 *
 * `GET /ARIS/v4/journey/v2/momentum`: three dimensions, each a state (or the
 * establishing `why` for NOT_ENOUGH_DATA), a direction and a `why`. The v1
 * trend chart, drivers and counts are gone — there is nothing to plot, and no
 * number may be shown (§8.5).
 */
function Momentum() {
  useStandaloneHeader();
  const [state, setState] = useState({ loading: true, momentum: null, error: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const momentum = await getMomentum();
        if (!cancelled) setState({ loading: false, momentum, error: false });
      } catch (e) {
        console.error("Failed to load momentum", e);
        if (!cancelled) setState({ loading: false, momentum: null, error: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const c = JOURNEY_HOME_COPY.momentum;

  return (
    <div className="journey-page">
      <div className="journey-page__inner">
        <JourneyBackHeader to="/journey" />
        <JourneySubpageCard>
          <JourneySectionHead title={c.title} subtitle={c.subtitle} />
          {state.loading && <div className="journey-card journey-card--status">Loading…</div>}
          {!state.loading && (state.error || !state.momentum?.dimensions?.length) && (
            <div className="journey-card journey-card--status">
              Momentum isn't available just now. Please try again in a moment.
            </div>
          )}
          <MomentumDimensions momentum={state.momentum} />
        </JourneySubpageCard>
      </div>
    </div>
  );
}

export default Momentum;
